import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
/* Get all Tickets based on Job Id  that's present */

import { TicketDetails } from './index';

export const GetTicketsByJobIdQuery = gql`
  query GetAllTickets($jobId: Int) {
    all_tickets(job_id: $jobId) {
      edges {
        node {
          ...TicketDetails
        }
      }
    }
  }
  ${TicketDetails}
`;

const marshallJobTicketData = ({ data, ownProps }) => {
  const allJobTickets = querySelector(data, '$.all_tickets.edges[*].node', []);
  const [currentJob] = querySelector(data, '$.all_tickets.edges[*].node.job', []);

  return {
    ...ownProps,
    data,
    allJobTickets,
    currentJob,
  };
};

const queryJobTicketData = graphql(GetTicketsByJobIdQuery, {
  props: marshallJobTicketData,
});

export const queryAllJobTicketsGQL = compose(
  queryJobTicketData,
  queryMetaHandler,
  omitProps(['data']),
);
